import { RootState } from 'editor/src/store/index';
import getAreaTokenForSpreadName from 'editor/src/store/livePreview/selector/getAreaTokenForSpreadName';

import findSpreadGroundImage from 'editor/src/util/design/findSpreadGroundImage';

const getSpreadForegroundImage = (state: RootState, spreadName: string) =>
  findSpreadGroundImage(state.design.spreadForegrounds, spreadName) ??
  findSpreadGroundImage(state.design.spreadForegrounds, getAreaTokenForSpreadName(state, spreadName));

export default getSpreadForegroundImage;
